import { TBaseItem } from "@centricsoftware/design-system";
import { C8NodeType } from "c8-platform";
import { NamesResult, StoreNames } from "csi/store/Names";
import { DISABLED_PROPERTY } from "csi/store/common";
import { isNullOrUndefined } from "csi/utility/coreUtility";
import { ILocaleProvider } from "designSystem/locale";
import _ from "lodash";

/** convert item from c8 store format to TBaseItem */
export function convertNameStoreValueToItem(val: NamesResult, store: StoreNames): TBaseItem | null {
	if (isNullOrUndefined(val)) {
		return null;
	}

	// don't add empty values to the dropdown
	if (store.getIdentity(val) === store.emptyValue) {
		return;
	}

	const { idProperty = "id", labelProperty = "name" } = store;
	const item: TBaseItem = {
		disabled: val[DISABLED_PROPERTY],
		id: val[idProperty],
		invalid: val._invalid,
		name: val[labelProperty],
	};
	return item;
}

/** convert data from c8 store format to mui select TBaseItem / TMultiSelectItem format */
export function convertNamesStoreDataToItems(data: NamesResult[], store: StoreNames): TBaseItem[] {
	return _.compact(data.map((val) => convertNameStoreValueToItem(val, store)));
}

/** return select option given type */
export function createSelectOptionByType(type: C8NodeType, loc: ILocaleProvider, includeTypeInName?: boolean): TBaseItem {
	const name = loc.type(type);

	return {
		id: type,
		name: includeTypeInName ? `${name} (${type})` : name,
	};
}

/** return true if given value is empty */
export function isSelectValueEmpty(value?: string | TBaseItem): boolean {
	const item = value as TBaseItem;
	return !value || !item.id;
}
